import SmartTipStatus from './SmartTipStatus';

export default SmartTipStatus;
